(function () {
  'use strict';

  var ROW_SELECTOR = '.bioss-citeab-card-citations[data-bioss-citeab-card]';
  var CARD_SELECTOR = [
    '.products-list .box.product',
    '.products .box.product',
    '.search-results .box.product',
    '.collection .box.product',
    '.product-card',
    '.product-item',
    '[data-product-handle]',
    '[data-product-id]'
  ].join(', ');

  var CACHE_PREFIX = 'bioss:citeab-cited:v162:';
  var CACHE_TTL_MS = 6 * 60 * 60 * 1000;
  var MAX_CARDS_PER_SCAN = 200;
  var RESCAN_DELAY_MS = 150;
  var PERIODIC_RESCAN_MS = 1500;
  var PERIODIC_RESCAN_LIMIT_MS = 120000;
  var startedAt = Date.now();
  var scanTimer = null;
  var requests = {};

  function normalizeText(text) {
    return (text || '').replace(/&nbsp;/gi, ' ').replace(/\s+/g, ' ').trim();
  }

  function absolutizeProductUrl(url) {
    if (!url) return '';
    url = String(url).split('#')[0].trim();
    var match = url.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? '/products/' + match[1] : '';
  }

  function productUrlFromCard(card) {
    if (!card) return '';

    var direct = card.getAttribute('data-product-url') || card.getAttribute('data-url');
    if (direct && direct.indexOf('/products/') !== -1) return absolutizeProductUrl(direct);

    var handle = card.getAttribute('data-product-handle') || card.getAttribute('data-handle');
    if (handle) return '/products/' + String(handle).replace(/^\/products\//, '').replace(/^\//, '').split(/[?#]/)[0];

    // Reuse the image-slider metadata when SearchSpring/card markup does not expose a normal product URL yet.
    var imageSlot = card.querySelector('[data-bioss-product-card-image], .bioss-card-image-loader, .bioss-card-image-injected');
    if (imageSlot) {
      var slotUrl = imageSlot.getAttribute('data-product-url');
      if (slotUrl && slotUrl.indexOf('/products/') !== -1) return absolutizeProductUrl(slotUrl);

      var endpoint = imageSlot.getAttribute('data-images-endpoint') || '';
      if (endpoint && endpoint.indexOf('/products/') !== -1) return absolutizeProductUrl(endpoint);
    }

    var link = card.querySelector('a.product-title[href], header a[href*="/products/"], h1 a[href*="/products/"], h2 a[href*="/products/"], h3 a[href*="/products/"], a[href*="/products/"]');
    if (!link) return '';

    var href = link.getAttribute('href') || '';
    if (href.indexOf('/products/') === -1) return '';
    return absolutizeProductUrl(href);
  }

  function productHandleFromUrl(productUrl) {
    if (!productUrl) return '';
    var match = productUrl.match(/\/products\/([^/?#]+)/i);
    return match && match[1] ? match[1] : '';
  }

  function endpointFromProductUrl(productUrl) {
    var handle = productHandleFromUrl(productUrl);
    return handle ? '/products/' + handle + '?view=published-citation&bioss_pub_v=162' : '';
  }

  function productSkuFromCard(card) {
    var sku = card.getAttribute('data-product-sku') || card.getAttribute('data-sku') || '';
    if (sku) return normalizeText(sku);

    var text = card.textContent || '';
    var match = text.match(/Catalog\s*#\s*:?\s*([A-Za-z0-9\-]+)/i);
    return match && match[1] ? normalizeText(match[1]) : '';
  }

  function descriptionContainer(card) {
    return card.querySelector('.description.rte, .description, figcaption, .product-card__info, .product-item__info') || card;
  }

  function removeRating(card) {
    var ratings = card.querySelectorAll('.bioss-citeab-card-rating[data-bioss-citeab-rating], .bioss-citeab-card-rating');
    for (var i = 0; i < ratings.length; i += 1) {
      if (ratings[i] && ratings[i].parentNode) ratings[i].parentNode.removeChild(ratings[i]);
    }
  }

  function citationLinkFromRow(row) {
    if (!row) return null;
    if (row.matches && row.matches('.bioss-citeab-card-link')) return row;
    return row.querySelector ? row.querySelector('.bioss-citeab-card-link') : null;
  }

  function normalizeExistingRow(row, productUrl, sku) {
    if (!row) return;
    row.hidden = false;
    row.removeAttribute('hidden');

    if (row.tagName && row.tagName.toLowerCase() !== 'a') {
      var oldLink = row.querySelector ? row.querySelector('.bioss-citeab-card-link') : null;
      var oldHref = oldLink ? oldLink.getAttribute('href') : '';
      var anchorRow = document.createElement('a');
      anchorRow.className = (row.className || 'bioss-citeab-card-citations') + ' bioss-citeab-card-link';
      anchorRow.href = oldHref || ((productUrl || '#') + '#bioss-citeab-citations');

      for (var attrIndex = 0; attrIndex < row.attributes.length; attrIndex += 1) {
        var attr = row.attributes[attrIndex];
        if (attr && attr.name !== 'class') anchorRow.setAttribute(attr.name, attr.value);
      }

      while (row.firstChild) {
        var child = row.firstChild;
        if (child === oldLink) {
          while (oldLink.firstChild) anchorRow.appendChild(oldLink.firstChild);
          row.removeChild(oldLink);
        } else {
          anchorRow.appendChild(child);
        }
      }

      if (row.parentNode) {
        row.parentNode.replaceChild(anchorRow, row);
        row = anchorRow;
      }
    }
    row.removeAttribute('data-citation-count');
    row.removeAttribute('data-citeab-count-endpoint');
    row.setAttribute('data-bioss-published-antibody', 'true');
    row.setAttribute('data-bioss-citeab-loaded', 'tagged');
    ensureExactIcon(row);
    if (productUrl) row.setAttribute('data-product-url', productUrl);
    if (sku) row.setAttribute('data-product-sku', sku);

    var text = row.querySelector('[data-bioss-citeab-text]');
    if (text) text.textContent = "View This Product's Citations";

    var link = citationLinkFromRow(row);
    if (link && productUrl) link.href = productUrl + '#bioss-citeab-citations';
    if (link) wireCitationLink(link);

    var widgetSource = row.querySelector('.bioss-citeab-card-widget-source');
    if (widgetSource && widgetSource.parentNode) widgetSource.parentNode.removeChild(widgetSource);

    var parentCard = row.closest ? row.closest(CARD_SELECTOR) : null;
    if (parentCard) placeRowAfterReactivity(parentCard, row);
  }

  function citationSettings() {
    return window.BiossCiteAbCardCitationSettings || {};
  }

  function guaranteeIconImg() {
    var iconUrl = citationSettings().iconUrl || '';
    if (!iconUrl) return null;

    var img = document.createElement('img');
    img.className = 'bioss-citeab-card-symbol';
    img.src = iconUrl;
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.loading = 'lazy';
    return img;
  }

  function exactCitationIcon() {
    return guaranteeIconImg() || guaranteeIconSvg();
  }

  function ensureExactIcon(row) {
    if (!row) return;
    var first = row.querySelector('.bioss-citeab-card-symbol, .bioss-citeab-card-symbol-svg, .bioss-citeab-card-symbol--fallback');
    var exact = exactCitationIcon();
    if (!exact) return;

    if (first && first.parentNode) {
      first.parentNode.replaceChild(exact, first);
      return;
    }

    row.insertBefore(exact, row.firstChild);
  }

  function guaranteeIconSvg() {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('class', 'bioss-citeab-card-symbol bioss-citeab-card-symbol-svg');
    svg.setAttribute('viewBox', '0 0 41 41');
    svg.setAttribute('width', '41');
    svg.setAttribute('height', '41');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');

    var paths = [
      { d: 'M21,9 C14.3818018,9 9,14.3804004 9,20.9990968 C9,27.6110191 14.3818018,33 21,33 C27.6200045,33 33,27.6105675 33,20.9990968 C33,14.3804004 27.6200045,9 21,9 Z M21,30.9646244 C15.512531,30.9646244 11.0374802,26.4997591 11.0374802,21.0013548 C11.0374802,15.5134728 15.5037706,11.0380852 21,11.0380852 C26.4962294,11.0380852 30.9625198,15.5117567 30.9625198,21.0013548 C30.9625198,26.4892368 26.4891849,30.9646244 21,30.9646244 Z', fill: '#40209E' },
      { d: 'M40.3259547,22.1567041 L39.5813697,21.149517 C39.2308764,20.6797484 39.2217969,20.0337711 39.5741057,19.5568503 L40.300513,18.5407343 C40.8743864,17.7435126 41.0795936,16.7363255 40.8489564,15.7807073 C40.6183238,14.8233123 39.98452,14.0118773 39.1019525,13.5492154 L37.9887478,12.9619591 C37.4566689,12.6843529 37.1769847,12.1148997 37.2695929,11.5347956 L37.4838842,10.3104909 C37.6473247,9.34598932 37.3821872,8.35479221 36.7574769,7.59137272 C36.1236777,6.82795323 35.1902501,6.36706798 34.1968968,6.32438245 L32.9292985,6.27455837 C32.329995,6.24964497 31.8160938,5.8545911 31.6544478,5.29229014 L31.2876133,4.10889426 C30.8590306,2.6568119 29.4806837,1.64247257 27.9315881,1.64247257 C27.4612481,1.64247257 26.9890949,1.73500495 26.5532505,1.92007883 L25.3891856,2.40588295 C24.8498078,2.63187936 24.1906251,2.49129956 23.8056409,2.06243529 L22.957569,1.13888813 C22.2947136,0.419976387 21.3449215,0 20.3606802,0 C19.3491492,0 18.3921047,0.42886427 17.7219968,1.17446699 L16.899355,2.1140497 C16.5143614,2.55002974 15.862394,2.70130598 15.3158102,2.48418834 L14.1426798,2.01441977 C13.7140971,1.84714444 13.2691779,1.75461205 12.8151558,1.75461205 C11.2497422,1.75461205 9.86229255,2.78671803 9.4500651,4.27082593 L9.11591772,5.4702118 C8.96155674,6.0325492 8.44762296,6.43471338 7.84831947,6.46851558 L6.58983327,6.54325397 C5.59647994,6.5930826 4.66305231,7.07178917 4.04738432,7.84409199 C3.4299497,8.61639481 3.18294795,9.61469859 3.36091194,10.5703168 L3.59154453,11.7875149 C3.70232107,12.3658423 3.42083764,12.9459919 2.8978197,13.230714 L1.79368054,13.8339602 C0.920178611,14.3126577 0.295445049,15.1347982 0.081172316,16.0903709 C-0.133119013,17.0477659 0.081172316,18.0531763 0.673176869,18.8415147 L1.41776183,19.8398184 C1.76825512,20.309587 1.77733463,20.9555644 1.42502544,21.4324852 L0.696804982,22.4486011 C0.122931557,23.2458228 -0.0822756129,24.2530099 0.148361625,25.2086282 C0.378994214,26.1660231 1.01279799,26.9792348 1.89536548,27.44012 L3.00857021,28.0273763 C3.54064906,28.304978 3.82033332,28.8744358 3.7277251,29.4545398 L3.51343377,30.6788445 C3.3518064,31.6433461 3.6151308,32.6345432 4.24165423,33.3979627 C4.87545336,34.1613822 5.80888099,34.6222675 6.8004212,34.664953 L8.06801945,34.7147816 C8.66732295,34.7396946 9.18122418,35.1347489 9.34287015,35.6970499 L9.69336344,36.8875524 C10.1219461,38.3396348 11.500293,39.3539741 13.0493886,39.3539741 C13.5197287,39.3539741 13.9918818,39.2614417 14.4277262,39.0763678 L15.5917911,38.5905637 C16.1311689,38.3645673 16.7921647,38.5069283 17.1753359,38.935788 L18.0234077,39.8575585 C18.6917025,40.5800236 19.6414946,41 20.6257824,41 C21.6373133,41 22.5943579,40.572917 23.2644658,39.825533 L24.0944065,38.8859503 C24.4794001,38.4499703 25.1313675,38.298694 25.6779513,38.5158117 L26.8510817,38.9855802 C27.2796644,39.1528556 27.7245836,39.2453879 28.1786056,39.2453879 C29.7440193,39.2453879 31.1314689,38.213282 31.5418833,36.7291741 L31.8760307,35.5297882 C32.0303916,34.9674508 32.5443254,34.5652866 33.1436289,34.5314844 L34.4112272,34.456746 C35.4136461,34.3980204 36.3380081,33.9282108 36.9536761,33.155908 C37.5711107,32.3836052 37.8181125,31.3941847 37.6401485,30.4296832 L37.4095159,29.2124851 C37.2987394,28.632381 37.5802228,28.0540081 38.1032407,27.769286 L39.2073799,27.1642631 C40.0808818,26.6855657 40.7056154,25.8634251 40.9198881,24.9078524 C41.1323617,23.9522341 40.9180718,22.945047 40.3260705,22.1567087 Z', fill: '#BADE26' },
      { d: 'M23.960897,17.366925 L18.7361117,22.9175694 L17.0386427,21.0945822 C16.5713703,20.5952024 15.8208265,20.5952024 15.3514951,21.0945822 C14.8842227,21.5939621 14.8842227,22.3960776 15.3432242,22.8976578 L17.8884221,25.6265668 C18.1117237,25.865212 18.4135894,26 18.7361509,26 C19.0483539,26 19.3502462,25.865212 19.5755697,25.6265668 L25.6482426,19.1767886 C26.115515,18.6774088 26.115515,17.8752933 25.6585809,17.373713 C25.1892389,16.8765393 24.428379,16.8765393 23.9611119,17.3670845 Z', fill: '#40209E' }
    ];

    for (var i = 0; i < paths.length; i += 1) {
      var path = document.createElementNS(svgNS, 'path');
      path.setAttribute('d', paths[i].d);
      path.setAttribute('fill', paths[i].fill);
      svg.appendChild(path);
    }

    return svg;
  }


  function findReactivityRow(container) {
    if (!container || !container.querySelectorAll) return null;
    var candidates = container.querySelectorAll('p, li, div, span');
    for (var i = 0; i < candidates.length; i += 1) {
      var el = candidates[i];
      var text = normalizeText(el.textContent || '');
      if (/^Reactivity\s*:/i.test(text) || /\bReactivity\s*:/i.test(text)) return el;
    }
    return null;
  }

  function placeRowAfterReactivity(card, row) {
    if (!card || !row) return false;
    var container = descriptionContainer(card);
    var reactivityRow = findReactivityRow(container);
    if (reactivityRow && reactivityRow.parentNode) {
      reactivityRow.parentNode.insertBefore(row, reactivityRow.nextSibling);
      return true;
    }
    container.appendChild(row);
    return false;
  }

  function citationHrefFromElement(link) {
    if (!link) return '';

    var href = link.getAttribute('href') || '';
    var hasProductHref = href && href.indexOf('/products/') !== -1;

    if (hasProductHref && href.indexOf('#bioss-citeab-citations') !== -1) return href;

    var card = link.closest ? link.closest(CARD_SELECTOR) : null;
    var productUrl = '';

    if (card) productUrl = productUrlFromCard(card);
    if (!productUrl) productUrl = link.getAttribute('data-product-url') || '';
    if (!productUrl && card) {
      var row = card.querySelector(ROW_SELECTOR);
      if (row) productUrl = row.getAttribute('data-product-url') || '';
    }

    productUrl = absolutizeProductUrl(productUrl);
    if (productUrl) return productUrl + '#bioss-citeab-citations';

    return href || '';
  }

  function navigateCitationLink(link, event) {
    var href = citationHrefFromElement(link);
    if (!href || href === '#') return false;

    if (event) {
      event.preventDefault();
      event.stopPropagation();
      if (event.stopImmediatePropagation) event.stopImmediatePropagation();
    }

    if (link && href !== link.getAttribute('href')) link.setAttribute('href', href);
    window.location.assign(href);
    return true;
  }

  function wireCitationLink(link) {
    if (!link || link.getAttribute('data-bioss-single-click-wired') === 'true') return;
    link.setAttribute('data-bioss-single-click-wired', 'true');

    link.addEventListener('click', function (event) {
      navigateCitationLink(link, event);
    }, true);
  }

  function createCitationRow(productUrl, sku) {
    var row = document.createElement('a');
    row.className = 'bioss-citeab-card-citations bioss-citeab-card-link';
    row.href = (productUrl || '#') + '#bioss-citeab-citations';
    row.setAttribute('data-bioss-citeab-card', 'true');
    row.setAttribute('data-bioss-published-antibody', 'true');
    row.setAttribute('data-bioss-citeab-loaded', 'tagged');
    row.setAttribute('aria-label', "View this product's citations");
    if (productUrl) row.setAttribute('data-product-url', productUrl);
    if (sku) row.setAttribute('data-product-sku', sku);

    var icon = exactCitationIcon();

    var text = document.createElement('span');
    text.setAttribute('data-bioss-citeab-text', 'true');
    text.textContent = "View This Product's Citations";

    row.appendChild(icon);
    row.appendChild(text);
    wireCitationLink(row);
    return row;
  }

  function insertRow(card, productUrl, sku) {
    if (!card) return;
    removeRating(card);

    var row = card.querySelector(ROW_SELECTOR);
    if (row) {
      normalizeExistingRow(row, productUrl, sku);
      return;
    }

    row = createCitationRow(productUrl, sku);
    placeRowAfterReactivity(card, row);
  }

  function removeRows(card) {
    removeRating(card);
    var rows = card.querySelectorAll(ROW_SELECTOR);
    for (var i = 0; i < rows.length; i += 1) {
      if (rows[i] && rows[i].parentNode) rows[i].parentNode.removeChild(rows[i]);
    }
  }

  function cacheKey(endpoint) {
    return endpoint ? CACHE_PREFIX + endpoint : '';
  }

  function readCache(endpoint) {
    var key = cacheKey(endpoint);
    if (!key || !window.localStorage) return null;
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.expires || parsed.expires < Date.now()) {
        window.localStorage.removeItem(key);
        return null;
      }
      return parsed.payload || null;
    } catch (error) {
      return null;
    }
  }

  function writeCache(endpoint, payload) {
    var key = cacheKey(endpoint);
    if (!key || !window.localStorage) return;
    try {
      window.localStorage.setItem(key, JSON.stringify({
        payload: payload,
        expires: Date.now() + CACHE_TTL_MS
      }));
    } catch (error) {}
  }

  function parsePayloadText(text) {
    if (!text) return null;
    try {
      return JSON.parse(text);
    } catch (error) {
      var start = text.indexOf('{');
      var end = text.lastIndexOf('}');
      if (start > -1 && end > start) {
        try { return JSON.parse(text.slice(start, end + 1)); } catch (e) {}
      }
    }
    return null;
  }

  function payloadIsPublished(payload) {
    if (!payload) return false;
    return payload.citeab_cited === true || String(payload.citeab_cited || '').toLowerCase() === 'true';
  }

  function fetchJson(endpoint) {
    if (!endpoint || !window.fetch) return Promise.resolve(null);

    var cached = readCache(endpoint);
    if (cached) return Promise.resolve(cached);

    if (requests[endpoint]) return requests[endpoint];

    requests[endpoint] = window.fetch(endpoint, {
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (response) {
        if (!response || !response.ok) return null;
        return response.text();
      })
      .then(function (text) {
        var payload = parsePayloadText(text);
        if (payload) writeCache(endpoint, payload);
        return payload;
      })
      .catch(function () { return null; });

    return requests[endpoint];
  }

  function fetchPublishedStatus(productUrl) {
    var endpoint = endpointFromProductUrl(productUrl);
    return fetchJson(endpoint);
  }

  function processCard(card) {
    if (!card || (card.classList && card.classList.contains('article'))) return;

    var status = card.getAttribute('data-bioss-published-citation-status');
    if (status === 'tagged' || status === 'unpublished' || status === 'loading') return;

    var existingRow = card.querySelector(ROW_SELECTOR);
    var productUrl = productUrlFromCard(card);
    var sku = productSkuFromCard(card);

    if (existingRow && existingRow.getAttribute('data-bioss-published-antibody') === 'true') {
      normalizeExistingRow(existingRow, productUrl, sku);
      removeRating(card);
      card.setAttribute('data-bioss-published-citation-status', 'tagged');
      return;
    }

    if (!productUrl) {
      // SearchSpring/card apps sometimes add links after first paint. Do not mark done; retry.
      card.removeAttribute('data-bioss-published-citation-status');
      return;
    }

    card.setAttribute('data-bioss-published-citation-status', 'loading');
    fetchPublishedStatus(productUrl).then(function (payload) {
      if (payloadIsPublished(payload)) {
        insertRow(card, productUrl, (payload && payload.sku) || sku);
        card.setAttribute('data-bioss-published-citation-status', 'tagged');
      } else {
        removeRows(card);
        card.setAttribute('data-bioss-published-citation-status', 'unpublished');
      }
    }).catch(function () {
      // Retry later rather than permanently suppressing the CTA.
      card.removeAttribute('data-bioss-published-citation-status');
    });
  }

  function scanCards() {
    var cards = document.querySelectorAll(CARD_SELECTOR);
    var processed = 0;
    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      // Avoid processing nested product-id children when a real card wrapper is nearby.
      var parentCard = card.parentElement && card.parentElement.closest ? card.parentElement.closest(CARD_SELECTOR) : null;
      if (parentCard && parentCard !== card && card.matches('[data-product-id], [data-product-handle]')) continue;
      processCard(card);
      processed += 1;
      if (processed >= MAX_CARDS_PER_SCAN) break;
    }

    var rows = document.querySelectorAll(ROW_SELECTOR);
    for (var j = 0; j < rows.length; j += 1) {
      var parent = rows[j].closest ? rows[j].closest(CARD_SELECTOR) : null;
      normalizeExistingRow(rows[j], parent ? productUrlFromCard(parent) : rows[j].getAttribute('data-product-url'), parent ? productSkuFromCard(parent) : rows[j].getAttribute('data-product-sku'));
      if (parent) removeRating(parent);
    }
  }

  function resetUnresolvedCards() {
    var loading = document.querySelectorAll('[data-bioss-published-citation-status="loading"]');
    for (var i = 0; i < loading.length; i += 1) {
      loading[i].removeAttribute('data-bioss-published-citation-status');
    }
  }

  function scheduleScan() {
    if (scanTimer) window.clearTimeout(scanTimer);
    scanTimer = window.setTimeout(function () {
      scanTimer = null;
      scanCards();
    }, RESCAN_DELAY_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanCards);
  } else {
    scanCards();
  }

  if (window.MutationObserver) {
    var observer = new MutationObserver(function () {
      scheduleScan();
    });
    observer.observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  window.addEventListener('load', function () {
    resetUnresolvedCards();
    scheduleScan();
    window.setTimeout(scheduleScan, 800);
    window.setTimeout(scheduleScan, 2000);
  });

  function citationLinkFromEvent(event) {
    return event && event.target && event.target.closest ? event.target.closest('.bioss-citeab-card-link, .bioss-citeab-card-citations[data-bioss-citeab-card]') : null;
  }

  function stopCitationPointerHijack(event) {
    var citationLink = citationLinkFromEvent(event);
    if (!citationLink) return;
    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();
  }

  document.addEventListener('pointerdown', stopCitationPointerHijack, true);
  document.addEventListener('mousedown', stopCitationPointerHijack, true);
  document.addEventListener('touchstart', stopCitationPointerHijack, true);

  document.addEventListener('click', function (event) {
    var citationLink = citationLinkFromEvent(event);
    if (citationLink) {
      if (navigateCitationLink(citationLink, event)) return;
    }

    var target = event.target;
    if (target && target.closest && target.closest('.searchspring-facets, .filter-menu, .collection-sidebar, .pagination')) {
      window.setTimeout(function () { resetUnresolvedCards(); scheduleScan(); }, 300);
      window.setTimeout(function () { resetUnresolvedCards(); scheduleScan(); }, 900);
      window.setTimeout(function () { resetUnresolvedCards(); scheduleScan(); }, 1800);
    }
  }, true);

  var periodic = window.setInterval(function () {
    if (Date.now() - startedAt > PERIODIC_RESCAN_LIMIT_MS) {
      window.clearInterval(periodic);
      return;
    }
    resetUnresolvedCards();
    scheduleScan();
  }, PERIODIC_RESCAN_MS);
})();
